module.exports = __webpack_public_path__ + "img/cover_default_image.9dc2ff44.png";